import { SUPPORTED_CHAIN_IDS } from '@ui/constants/chain';
import { useDataChainId } from '@ui/hooks/datachain';
import { Position } from '@ui/services/contract/hooks/TradingReaderFacet/useGetPositionV3/types';
import { ChainId } from '@ui/types/chain';
import { create } from 'zustand';

interface PendingTradesState {
  pendingTradesMap: Record<ChainId, Position[]>;
  usePendingTrades: () => Position[];
  addPendingTrade: (pendingTrade: Position, chainId: ChainId) => void;
  removePendingTrade: (tradeId: string, chainId: ChainId) => void;
  resetPendingTrades: () => void;
}

const defaultMap = Object.fromEntries(
  SUPPORTED_CHAIN_IDS.map((id) => [id, [] as Position[]]),
) as Record<ChainId, Position[]>;

export const usePendingTradesStore = create<PendingTradesState>()(
  (set, get) => ({
    pendingTradesMap: defaultMap,

    usePendingTrades: () => {
      const chainId = useDataChainId();

      return get().pendingTradesMap[chainId];
    },

    addPendingTrade: (pendingTrade, chainId) => {
      set((state) => {
        const list = state.pendingTradesMap[chainId] ?? [];
        const exists = list.some((t) => t.id === pendingTrade.id);
        const updated = exists
          ? list.map((t) => (t.id === pendingTrade.id ? pendingTrade : t))
          : [...list, pendingTrade];

        return {
          pendingTradesMap: {
            ...state.pendingTradesMap,
            [chainId]: updated,
          },
        };
      });
    },

    removePendingTrade: (tradeId, chainId) => {
      set((state) => {
        const list = state.pendingTradesMap[chainId] ?? [];

        return {
          pendingTradesMap: {
            ...state.pendingTradesMap,
            [chainId]: list.filter((t) => t.id !== tradeId),
          },
        };
      });
    },

    resetPendingTrades: () => {
      set({
        pendingTradesMap: defaultMap,
      });
    },
  }),
);
